import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ISceneState } from "../types";

export const sceneModuleName = "scene";

const initialState: ISceneState = {
  scale: 1,
};

export const sceneSlice = createSlice({
  initialState,
  name: sceneModuleName,
  reducers: {
    actionSetScale(state, { payload }: PayloadAction<ISceneState["scale"]>) {
      state.scale = payload;
    },
  },
});

export const {
  actions: { actionSetScale },
} = sceneSlice;

export const { reducer: sceneReducer } = sceneSlice;
